import { Icon } from "@chakra-ui/react"
import { FaFaceSmile } from "react-icons/fa6"
import { useAppSelector } from "../../app/hooks"
import MeterBar from "../../components/MeterBar"
import {
  selectGameMentalHealth,
  selectLastTurnMentalHealthEffect,
  selectLastTurnNonce,
} from "./gameSlice"

// Hoisted so the memoised MeterBar sees a stable icon prop
const ICON = <Icon boxSize={6} as={FaFaceSmile} />

export const MentalHealthMeter = () => {
  const value = useAppSelector(selectGameMentalHealth)
  const effect = useAppSelector(selectLastTurnMentalHealthEffect)
  const nonce = useAppSelector(selectLastTurnNonce)

  return (
    <MeterBar
      label="Happiness"
      value={value}
      max={100}
      icon={ICON}
      effect={effect}
      nonce={nonce}
    />
  )
}
